import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { Form, FormGroup, Input } from "reactstrap";
import Moment from "react-moment";
import { Creators as SubscriptionCreators } from "../../../store/ducks/subscription";
import Submit from "../../../components/Submit";
import Loading from "../../../components/Loading";

class Vouchers extends Component {
  static propTypes = {
    getSubscriptionMobileRequest: PropTypes.func.isRequired,
    applyVoucher: PropTypes.func.isRequired,
    getVouchersRequest: PropTypes.func.isRequired,
    user: PropTypes.shape.isRequired,
    subscription: PropTypes.shape.isRequired,
    loading: PropTypes.bool.isRequired
  };

  state = {
    voucherValue: ""
  };

  componentWillMount() {
    this.props.getVouchersRequest();
  }

  viewSubscriptionNone = () => (
    <p className="mt-3">Você não possui voucher ativo.</p>
  );

  viewSubscriptionVoucher = () =>
    this.props.subscription.subscription.data.subscription && (
      <div>{this.expirationDateMessage()}</div>
    );

  expirationDateMessage = () => {
    const dt = new Date(
      this.props.subscription.subscription.data.subscription.expire_date
    );

    const dtNow = new Date(Date.now());
    if (dt < dtNow) {
      return (
        <p>
          Seu acesso expirou em{" "}
          <strong>
            <Moment
              date={
                this.props.subscription.subscription.data.subscription
                  .expire_date
              }
              format="DD/MM/YYYY"
            />
          </strong>
          .
        </p>
      );
    }
    return (
      <div className="mt-4 mb-4">
        Seu acesso expira em{" "}
        <strong>
          <Moment
            date={
              this.props.subscription.subscription.data.subscription.expire_date
            }
            format="DD/MM/YYYY"
          />
        </strong>
        .
      </div>
    );
  };

  rowVoucher = voucher => {
    if (voucher.code === this.state.voucherValue) {
      this.setState({ voucherValue: "" });
    }

    return (
      <tr>
        <td>{voucher.code.trim()}</td>
        <td>
          <Moment date={voucher.activated_at} format="DD/MM/YYYY" />
        </td>
      </tr>
    );
  };

  submitVoucher = e => {
    e.preventDefault();
    this.props.applyVoucher(e.target.voucher.value.trim());
  };

  render() {
    const { loading } = this.props;
    return (
      <Fragment>
        <h1 className="title-underline">Vouchers</h1>

        <Form
          inline
          accept-charset="UTF-8"
          onSubmit={e => this.submitVoucher(e)}
          className="mt-4"
        >
          <FormGroup>
            <Input
              placeholder="Voucher"
              name="voucher"
              className="mr-2"
              value={this.state.voucherValue}
              onChange={t => this.setState({ voucherValue: t.target.value })}
              required
            />
            <Submit loading={loading} name="Ativar" />
          </FormGroup>
        </Form>

        {this.props.subscription.subscription.loading && <Loading />}

        {
          // NÃO POSSUI ASSINATURA
        }
        {!this.props.subscription.subscription.loading &&
          this.props.subscription.subscription.data.via !== "voucher" &&
          this.viewSubscriptionNone()}

        {
          // VOUCHER
        }
        {!this.props.subscription.subscription.loading &&
          this.props.subscription.subscription.data.via &&
          this.props.subscription.subscription.data.via === "voucher" &&
          this.viewSubscriptionVoucher()}

        {this.props.subscription.vouchers.data &&
          this.props.subscription.vouchers.data.length > 0 && (
            <table className="table">
              <thead>
                <tr className="table-secondary">
                  <th scope="col">Código</th>
                  <th scope="col">Data de Ativação</th>
                </tr>
              </thead>
              {this.props.subscription.vouchers.data.map(voucher =>
                this.rowVoucher(voucher)
              )}
            </table>
          )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  subscription: state.subscription,
  user: state.user,
  loading: false
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(SubscriptionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Vouchers);



// WEBPACK FOOTER //
// ./src/pages/admin/vouchers/index.js